import React from "react";

import TextInputWithValidation from "components/TextInputWithValidation";

interface NameInputProps {
  setName: (password: string) => void;
  value: string;
  isNameValid: (isValid: boolean) => void;
  displayErrors: boolean;
  disabled: boolean | undefined;
  dataTestId?: string;
}

const NameInput: React.FC<NameInputProps> = ({
  setName,
  value,
  isNameValid,
  displayErrors,
  disabled,
  dataTestId,
}) => {
  return (
    <TextInputWithValidation
      inputName="Name Input"
      id="name-input"
      setValue={setName}
      value={value}
      isValueValid={isNameValid}
      displayErrors={displayErrors}
      minLength={3}
      maxLength={256}
      label="Full name"
      disabled={disabled}
      dataTestId={dataTestId}
    />
  );
};

export default NameInput;
